import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import { handlePostRequest } from '../../services/PostTemplate';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ColorPicker } from 'primereact/colorpicker';
import Preview from '../Templates/Preview';
import PreviewSecond from '../Templates/PreviewSecond';
import Previewww from './Preview';

function AddNewUser() {
    const bankImageRef = useRef(null);
    const [categoryIconError, setCategoryIconError] = useState('');
    const [iconLink, setIconLink] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState('');
    const [showColorPicker, setShowColorPicker] = useState({ textColor: false, bgColor: false });

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const userId = localStorage.getItem('userId');

    const formik = useFormik({
        initialValues: {
            image: '',
            bankIcon: '',
            User_Name: '',
            User_Email: '',
            contact_number: '',
            Roleid: 1,
            CreatedBy: userId,
            Status_id: 1,
            StoreId: 1,
            StoreName: '',
            SiteLink: '',
            ApiaccessCode: '',
            PrimaryColor: '',
            SecondaryColor: '',
            wh_productcreate: 1,
            wh_productupdate: 1,
            wh_invupdate: 1,
            templatetype:1
        },
        validate: (data) => {
            let errors = {};

            if (!data?.User_Name) {
                errors.User_Name = 'This field is required';
            }

            if (!data?.User_Email) {
                errors.User_Email = 'This field is required';
            }
            if (!data?.contact_number) {
                errors.contact_number = 'This field is required';
            }

            if (!data?.StoreName) {
                errors.StoreName = 'This field is required';
            }

            if (!data?.SiteLink) {
                errors.SiteLink = 'This field is required';
            }

            if (!data?.EPSiteLink) {
                errors.EPSiteLink = 'This field is required';
            }

            if (!data?.ApiaccessCode) {
                errors.ApiaccessCode = 'This field is required';
            }

            if (!data?.PrimaryColor) {
                errors.PrimaryColor = 'This field is required';
            }
            if (!data?.SecondaryColor) {
                errors.SecondaryColor = 'This field is required';
            }
            if (!data?.bankIcon) {
                errors.image = 'This field is required';
            }

            return errors;
        },

        onSubmit: async (data) => {
            data['image'] = data?.bankIcon;
            delete data?.bankIcon;

            const formData = new FormData();

            formData.append('image', data?.image);
            formData.append('User_Name', data?.User_Name);
            formData.append('User_Email', data?.User_Email);
            formData.append('contact_number', data?.contact_number);
            formData.append('Roleid', data?.Roleid);
            formData.append('CreatedBy', data?.CreatedBy);
            formData.append('Status_id', data?.Status_id);
            formData.append('StoreId', data?.StoreId);
            formData.append('StoreName', data?.StoreName);
            formData.append('SiteLink', data?.SiteLink);
            formData.append('EPSiteLink', data?.EPSiteLink);
            formData.append('ApiaccessCode', data?.ApiaccessCode);
            formData.append('PrimaryColor', data?.PrimaryColor);
            formData.append('SecondaryColor', data?.SecondaryColor);
            formData.append('wh_productcreate', data?.wh_productcreate);
            formData.append('wh_productupdate', data?.wh_productupdate);
            formData.append('wh_invupdate', data?.wh_invupdate);
            formData.append('templatetype', data?.templatetype);

            setLoading(true);
            const response = await dispatch(handlePostRequest(formData, '/Authentication/AddNewUser', true));
            if (response?.statusCode === '200') {
                
            }
            setLoading(false)
        }
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handledProductIconClick = () => {
        bankImageRef.current.click();
    };
    const handleBankImageUpload = (event) => {
        setCategoryIconError('');
        const selectedFile = event.target.files[0];

        if (selectedFile) {
            const fileTypes = ['image'];
            const fileType = selectedFile.type.split('/')[0];

            if (!fileTypes.includes(fileType)) {
                setCategoryIconError('Invalid file type. Please select an image.');
                return;
            }

            setSelectedFile(selectedFile);
            formik.setFieldValue('bankIcon', selectedFile.name);
            setIconLink(URL.createObjectURL(selectedFile));
        } else {
            setSelectedFile(null);
            formik.setFieldValue('bankIcon', '');
            setIconLink('');
        }
    };

    let primaryColor= formik.values.PrimaryColor
    let secColor = formik.values.SecondaryColor
    
    return (
        <div className="card">
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-12">
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-4" style={{ maxHeight: '100vh' }}>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="User_Name" className={classNames({ 'p-error': isFormFieldValid('User_Name') }, 'Label__Text')}>
                                    User Name <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="User_Name"
                                    placeholder="Enter User Name"
                                    name="User_Name"
                                    value={formik?.values?.User_Name || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('User_Name') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('User_Name')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="User_Email" className={classNames({ 'p-error': isFormFieldValid('User_Email') }, 'Label__Text')}>
                                    User Email <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="User_Email"
                                    placeholder="Enter User Email"
                                    name="User_Email"
                                    value={formik?.values?.User_Email || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('User_Email') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('User_Email')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="contact_number" className={classNames({ 'p-error': isFormFieldValid('contact_number') }, 'Label__Text')}>
                                    Contact Number <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="contact_number"
                                    placeholder="Enter Contact Number"
                                    name="contact_number"
                                    value={formik?.values?.contact_number || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('contact_number') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('contact_number')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="StoreName" className={classNames({ 'p-error': isFormFieldValid('StoreName') }, 'Label__Text')}>
                                    Store Name <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="StoreName"
                                    placeholder="Enter Shopify Store Name"
                                    name="StoreName"
                                    value={formik?.values?.StoreName || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('StoreName') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('StoreName')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="SiteLink" className={classNames({ 'p-error': isFormFieldValid('SiteLink') }, 'Label__Text')}>
                                    Site Link <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="SiteLink"
                                    placeholder="Enter Site Link"
                                    name="SiteLink"
                                    value={formik?.values?.SiteLink || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('SiteLink') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('SiteLink')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="EPSiteLink" className={classNames({ 'p-error': isFormFieldValid('EPSiteLink') }, 'Label__Text')}>
                                    EP Site Link <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="EPSiteLink"
                                    placeholder="Enter EP Site Link"
                                    name="EPSiteLink"
                                    value={formik?.values?.EPSiteLink || ''}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('EPSiteLink') }, 'Input__Round')}
                                />
                                <small className="p-error">{formik.errors['EPSiteLink']}</small>
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="ApiaccessCode" className={classNames({ 'p-error': isFormFieldValid('ApiaccessCode') }, 'Label__Text')}>
                                    Api Access Code <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    maxLength={100}
                                    id="ApiaccessCode"
                                    placeholder="Enter Api Access Code"
                                    name="ApiaccessCode"
                                    value={formik?.values?.ApiaccessCode || ''}
                                    onChange={formik.handleChange}
                                    className={classNames({ 'p-invalid': isFormFieldValid('ApiaccessCode') }, 'Input__Round')}
                                />
                                {getFormErrorMessage('ApiaccessCode')}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="PrimaryColor" className={classNames({ 'p-error': isFormFieldValid('PrimaryColor') }, 'Label__Text')}>
                                    Primary Color <span className="Label__Required">*</span>
                                </label>
                                <div className="flex align-items-center gap-2">
                                    <InputText
                                        maxLength={7}
                                        id="PrimaryColor"
                                        placeholder="Enter Color Code"
                                        name="PrimaryColor"
                                        value={formik?.values?.PrimaryColor || ''}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('PrimaryColor') }, 'Input__Round')}
                                    />
                                    <ColorPicker
                                        id="PrimaryColor"
                                        name="PrimaryColor"
                                        value={formik.values.PrimaryColor}
                                        onChange={(e) => formik.setFieldValue('PrimaryColor', `#${e.value}`)}
                                        style={{ width: '40px', height: '20px', padding: '0', border: 'none', marginTop: '-10px' }}
                                    />
                                </div>
                                {getFormErrorMessage('PrimaryColor')}
                            </div>
                        </div>

                        <div className="p-field col-12 md:col-12 pt-3 pb-3">
                            <div className="p-field">
                                <label htmlFor="SecondaryColor" className={classNames({ 'p-error': isFormFieldValid('SecondaryColor') }, 'Label__Text')}>
                                    Secondary Color <span className="Label__Required">*</span>
                                </label>
                                <div className="flex align-items-center gap-2">
                                    <InputText
                                        maxLength={7}
                                        id="SecondaryColor"
                                        placeholder="Enter Color Code"
                                        name="SecondaryColor"
                                        value={formik?.values?.SecondaryColor || ''}
                                        onChange={formik.handleChange}
                                        className={classNames({ 'p-invalid': isFormFieldValid('SecondaryColor') }, 'Input__Round')}
                                    />
                                    <ColorPicker
                                        id="SecondaryColor"
                                        name="SecondaryColor"
                                        value={formik.values.SecondaryColor}
                                        onChange={(e) => formik.setFieldValue('SecondaryColor', `#${e.value}`)}
                                        style={{ width: '40px', height: '20px', padding: '0', border: 'none', marginTop: '-10px' }}
                                    />
                                </div>
                                {getFormErrorMessage('SecondaryColor')}
                            </div>
                        </div>
                        <div
                            className="p-field col-12 md:col-12 pt-3 pb-3"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.5rem',
                                width: '100%'
                            }}
                        >
                            <div
                                className="p-field"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.5rem'
                                }}
                            >
                                <div className="mb-2">
                                    <label className={classNames({ 'p-error': isFormFieldValid('bankIcon') }, 'Label__Text')}>
                                        Icon
                                        <span className="Label__Required">*</span>
                                    </label>
                                    <div
                                        className="file-input-container w-100"
                                        onClick={handledProductIconClick}
                                        style={{
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            width: '100%',
                                            border: '2px solid #ddd',
                                            borderRadius: '8px',
                                            padding: '0.5rem',
                                            backgroundColor: '#f9f9f9',
                                            transition: 'border-color 0.3s ease',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <input type="file" accept="image/*" style={{ display: 'none' }} ref={bankImageRef} onChange={handleBankImageUpload} />
                                        <input
                                            type="text"
                                            className={classNames(
                                                {
                                                    'p-inputtext p-component p-invalid': isFormFieldValid('bankIcon')
                                                },
                                                'file-input-field Input__Round'
                                            )}
                                            style={{
                                                flex: 1,
                                                border: 'none',
                                                outline: 'none',
                                                backgroundColor: 'transparent',
                                                fontSize: '1rem',
                                                padding: '0',
                                                cursor: 'pointer'
                                            }}
                                            placeholder="Choose a file..."
                                            value={formik?.values?.bankIcon}
                                            readOnly
                                        />
                                        <span
                                            className="file-upload-icon"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginLeft: '0.5rem',
                                                color: '#666',
                                                fontSize: '1.2rem'
                                            }}
                                        >
                                            <i className="pi pi-paperclip" />
                                        </span>
                                    </div>
                                   
                                        {getFormErrorMessage('image')}
                                </div>
                            </div>
                        </div>
                        <div className="p-field">
                            <label>
                                <input type="checkbox" name="templatetype" value={1} checked={formik.values.templatetype === 1} onChange={() => formik.setFieldValue('templatetype', 1)} />
                                Preview One
                            </label>
                            <label className="ml-3">
                                <input type="checkbox" name="templatetype" value={2} checked={formik.values.templatetype === 2} onChange={() => formik.setFieldValue('templatetype', 2)} />
                                Preview Two
                            </label>
                        </div>
                        <div className="Down__Btn mt-8">
                            <div className="Down__Btn">
                                <Button type="submit" label="Add" className="Btn__Dark" disabled={loading} icon={loading ? 'pi pi-spinner pi-spin' : null} />
                                <Button onClick={() => navigate('/')} label="Cancel" className="Btn__Transparent" disabled={loading} />
                            </div>
                        </div>
                    </div>
                    <div className="p-fluid p-formgrid grid mb-5 col-12 md:col-8 pl-4 ml-auto">
                        <Previewww primaryColor={primaryColor} secColor={secColor} selectedFile={iconLink} />
                        {formik?.values.templatetype === 1 ? <PreviewSecond primaryColor={primaryColor} secColor={secColor} /> : <Preview primaryColor={primaryColor} secColor={secColor} />}
                    </div>
                </div>
            </form>
        </div>
    );
}

export default AddNewUser;
